import Vue from 'vue'

// import MouseLayoutDynamic from './components/layout/BasicLayoutDynamic'
// import MenuLayoutDynamic from './components/layout/MenuLayoutDynamic'

// Vue.component('basic-layout-dynamic', BasicLayoutDynamic)
// Vue.component('menu-layout-dynamic', MenuLayoutDynamic)

// components/commonのGlXxxxxは全て登録
const requireComponent = require.context(
  './components/common',
  false,
  /Gl[\w-]+\.vue$/,
)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')

  Vue.component(componentName, componentConfig.default || componentConfig)
})
